import { reactive } from 'vue';

export default function () {
  let targetShows = reactive({}); // targetShows[selector][checkするID] => [表示するID]
  let notShows = reactive({}); // notShows[selector][対象ID] = true // 表示しない

  const displayed = (selector) => {
    const displays = document.querySelectorAll(
      `${selector} .icj-display-on-off`
    );

    // 初期化 で、すべて表示させない
    Object.keys(notShows[selector]).forEach((id) => {
      notShows[selector][id] = true;
    });

    // チェックされているID
    let checkedIds = [];
    displays.forEach((el) => {
      if (el.checked || el.selected) {
        checkedIds.push(el.dataset.id);
      }
    });

    // 表示条件によって、表示させる
    checkedIds.forEach((checkedId) => {
      targetShows[selector][checkedId].forEach((condition_id) => {
        notShows[selector][condition_id] = false;
      });
    });
  };

  const runDisplayed = (formData, selector) => {
    notShows[selector] = {};
    targetShows[selector] = {};

    // データをセット
    formData.forEach((item) => {
      item.options.forEach((option) => {
        const condition_ids = option.display_conditions
          ? option.display_conditions.flatMap((data) => data.condition_id)
          : option.display_items.flatMap((data) => data.item_id);
        targetShows[selector][option.id] = condition_ids;
        condition_ids.forEach((condition_id) => {
          notShows[selector][condition_id] = true;
        });
      });
    });

    displayed(selector);
  };

  return {
    notShows,
    runDisplayed,
  };
}
